import React from 'react';
import ProPaywallModal from '@/components/ProPaywallModal';

export function OncoAgentPaywall({
  returnPath,
  onUnlocked,
}: {
  returnPath: string;
  onUnlocked: () => void;
}): React.ReactElement {
  return (
    <div className="oa-app" style={{ display: 'block', minHeight: '100vh', background: '#f6f4ef' }}>
      <div className="oa-app-paywall" style={{ position: 'relative', zIndex: 1 }}>
        <p className="oa-app-kicker">OncoAgent clinic workspace</p>
        <h1>A paid clinic seat is required</h1>
        <p>
          Referrals, inbox, clinic IDs, and specialty pathways live behind a ByOnco plan.
          Sign in is not enough. Admin accounts keep full access for operations.
        </p>
      </div>
      <ProPaywallModal
        open
        returnPath={returnPath}
        title="Unlock the OncoAgent clinic workspace"
        subtitle="Create referrals, run a clinic inbox, and keep clinic IDs on file. Plans start monthly. Admin@getbyonco.com already has full access."
        onClose={() => {
          window.location.href = '/oncoagent';
        }}
        onUnlocked={onUnlocked}
      />
    </div>
  );
}

export default OncoAgentPaywall;
